module.exports = __webpack_public_path__ + "it.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flags/it.png
// module id = 1065
// module chunks = 0